import { useNostoApi } from './useNostoApi';

/**
 * Sends product page viewed action to the Nosto.
 * @param productId - The unique identifier of the product.
 * @param productRef - Optional nosto slot reference.
 */
export function useNostoProduct(productId: string, productRef = '') {
  useNostoApi((api) => {
    const apiCall = api.defaultSession().viewProduct(productId);

    if (productRef?.trim()) {
      apiCall.setRef(productId, productRef);
    }

    return apiCall.load();
  }, 'PRODUCT');
}
